/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeBreakpointContext, BaSeIcon } from '@base/react';
import React from 'react';
import ReactPlayer from 'react-player';
import { useInterviewContext } from '../../context/interview-context';
import { useValidationsContext } from '../../context/validations-context';
import CommonButton from '../common-button/common-button';
import CommonCheckbox from '../common-checkbox/common-checkbox';
import {
  Container,
  ContentVideo,
  Description,
} from './video-apresentation-style';

export const VideoApresentation = () => {
  const breakpointController = React.useContext(BaSeBreakpointContext);

  const { interview } = useInterviewContext();
  const { viewVideo, setViewVideo, onVideoEnd } = useValidationsContext();

  if (!interview) {
    return <h1>carregando</h1>;
  }
  return (
    <Container>
      <Description>
        O Empretec é um programa transformador. Ele ativa comportamentos
        essenciais para quem quer empreender com propósito, consistência e
        impacto.
        <br />
        Antes de seguir, é importante que você assista ao vídeo abaixo. Ele
        apresenta o que é o Empretec, como funciona o seminário e o que você
        pode esperar dessa jornada. Esse é o momento de refletir:{' '}
        <strong>
          é agora o melhor momento para você viver essa experiência?
        </strong>
      </Description>

      <ContentVideo>
        <p>Assista ao vídeo completo para liberar o próximo passo</p>


        <CommonButton
          variant="primary"
          foregroundColor="#0015C1"
          style={{ cursor: 'auto' }}
          isBold={true}
          iconLeft={
            <BaSeIcon
              name="clock-three"
              description="imagem de relogio"
              color="#0015C1"
              size={20}
            />
          }
          backgroundColor="#EFBAF2"
          onClick={() => { }}
        >
          DURAÇÃO: MENOS DE 2 MINUTOS
        </CommonButton>
      </ContentVideo>

      <ReactPlayer
        url="https://player.vimeo.com/video/1179590195"
        width={
          breakpointController.inDesktop ||
            breakpointController.inDesktopLarge ||
            breakpointController.inTablet
            ? '70%'
            : '100%'
        }
        height="100%"
        controls={true}
        config={{
          vimeo: {
            playerOptions: {
              responsive: true,
              playsinline: true,
            },
          },
          file: {
            attributes: {
              poster: 'https://i.vimeocdn.com/video/1194054632?mw=1300&mh=731',
            },
          },
        }}
        onEnded={onVideoEnd}
      />

      <div style={{ display: 'flex' }}>
        <CommonCheckbox
          checked={viewVideo}
          name="view video"
          onChange={(isChecked) => {
            setViewVideo(isChecked);
          }}
        />
        <Description>
          Declaro que assisti ao vídeo e compreendi a proposta do Empretec.
          Estou pronto para seguir com minha jornada.
        </Description>
      </div>
    </Container>
  );
};
